import { Link } from "react-router-dom";

const stats = [
  { value: "20+", label: "精选影视作品" },
  { value: "4", label: "主题影视专题" },
  { value: "12", label: "持续更新资讯" },
  { value: "5", label: "多维筛选维度" },
];

export default function IntroSection() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-label font-semibold text-accent-700 mb-3">
              <span className="w-4 h-0.5 bg-accent-500 rounded-full"></span>
              关于缘之空
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              让每一次选片，都有据可依
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              缘之空是一个聚焦高清电影与电视剧的资讯与剧情介绍平台。我们把分散在各处的影视动态、剧情解析与推荐整合到一起，用清晰的分类和多维筛选，帮助你在海量作品里更快找到心仪的那一部。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              无论你是想追最新热剧、重温高分经典，还是查找一部剧的详细剧情，这里都能给出贴近观影需求的参考。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                了解我们
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/category/movie"
                className="inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 transition-colors whitespace-nowrap"
              >
                浏览影视库
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
                <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600 mb-1">{s.value}</p>
                <p className="text-xs md:text-sm text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}